import { Home } from "../components/Home";
export function HomeScreen() {
	return <Home />;
}
